// The job page's "Sales risk" (#668): Sales Risk Assessment opened at this job, in a new tab (Edge
// from the iPad web clip). Its address is the site's SALES_RISK_URL setting, from /api/me.
import { useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import { ShieldCheck } from 'lucide-react';
import { useOnline } from '../lib/hooks';
import { meAtom } from '../store/atoms';
import { HeaderOutboundLink } from './header-outbound-link';

const meLoadable = loadable(meAtom);

/** Sales Risk Assessment's page for one opportunity: the device's job id is the opportunity id. */
const salesRiskHref = (base: string, opportunityId: string): string => `${base}/?opportunity=${encodeURIComponent(opportunityId)}`;

export function SalesRiskLink({ jobId, jobNumber }: { jobId: string; jobNumber: string }) {
  const me = useAtomValue(meLoadable);
  const online = useOnline();
  const base = me.state === 'hasData' ? me.data.salesRiskUrl : null;
  if (!base) return null;
  return (
    <HeaderOutboundLink href={salesRiskHref(base, jobId)} blocked={online ? null : 'Opening Sales Risk Assessment needs signal.'} title={`Sales Risk Assessment for ${jobNumber}, in a new tab`}>
      <ShieldCheck className="h-4 w-4" /> Sales risk
    </HeaderOutboundLink>
  );
}
